import { render, staticRenderFns } from "./PatientDoctorDiscussion.vue?vue&type=template&id=ac93a48c&"
import script from "./PatientDoctorDiscussion.vue?vue&type=script&lang=ts&"
export * from "./PatientDoctorDiscussion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac93a48c')) {
      api.createRecord('ac93a48c', component.options)
    } else {
      api.reload('ac93a48c', component.options)
    }
    module.hot.accept("./PatientDoctorDiscussion.vue?vue&type=template&id=ac93a48c&", function () {
      api.rerender('ac93a48c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/PatientDoctorDiscussion.vue"
export default component.exports